<script lang="ts">
	import { resolve } from '$app/paths';
	import Popup from '$components/Popup.svelte';
	import { closeDrawer } from '$lib/shared/lib/drawerStore';
	import { page } from '$app/state';
	import Fa from 'svelte-fa';
	import {
		faGear,
		faPodcast,
		faLayerGroup,
		faCommentDots,
		faMicrophone,
		faImage,
		faBullseye,
		faCreditCard
	} from '@fortawesome/free-solid-svg-icons';

	interface Props {
		tag: string;
		selectedPath: string | null;
	}

	let { tag, selectedPath }: Props = $props();

	const settingsSections = [
		{ title: 'Show', path: 'show', icon: faPodcast },
		{ title: 'Overlay', path: 'overlay', icon: faLayerGroup },
		{ title: 'Text Tips', path: 'text-tips', icon: faCommentDots },
		{ title: 'Voice Tips', path: 'voice-tips', icon: faMicrophone },
		{ title: 'Image Tips', path: 'image-tips', icon: faImage },
		{ title: 'Goals', path: 'goals', icon: faBullseye },
		{ title: 'Payments', path: 'payments', icon: faCreditCard }
	];

	let isOnSettingsRoute = $derived(page.route.id?.startsWith('/admin/[tag]/settings/') ?? false);
	let settingsSubPath = $derived(
		isOnSettingsRoute ? (page.route.id!.split('/').filter((x) => x)[3] ?? null) : null
	);

	let popupOpen = $state(false);
	let triggerEl: HTMLButtonElement | undefined = $state();

	function handleClickOutside(event: MouseEvent) {
		if (!popupOpen) return;
		const target = event.target as Element | null;
		if (!target) return;
		if (target.closest('[data-flyout-popup]')) return;
		if (triggerEl && triggerEl.contains(target)) return;
		popupOpen = false;
	}

	function handleSectionClick() {
		popupOpen = false;
		closeDrawer();
	}
</script>

<svelte:window onclick={handleClickOutside} />

<!-- Trigger: gear icon button -->
<button
	bind:this={triggerEl}
	class="flex w-full items-center justify-center py-2 transition-colors hover:text-primary-500
		{selectedPath === 'settings' ? 'bg-surface-50-800 text-primary-500' : ''}"
	onclick={() => (popupOpen = !popupOpen)}
>
	<Fa icon={faGear} />
</button>

<Popup bind:open={popupOpen} {triggerEl} placement="right-start">
	<div data-flyout-popup>
		<div
			class="min-w-44 card rounded-lg border border-surface-200-800 bg-surface-100-900 shadow-xl"
		>
			<div class="p-2">
				<div class="px-3 py-1.5 text-xs font-semibold tracking-wide uppercase opacity-60">
					Settings
				</div>
				{#each settingsSections as section, _i (_i)}
					<a
						href={resolve(`/admin/${tag}/settings/${section.path}`)}
						class="flex items-center space-x-3 rounded px-3 py-1.5 text-sm transition-colors hover:preset-tonal-surface hover:text-primary-500
							{settingsSubPath === section.path ? 'bg-surface-50-800 text-primary-500' : ''}"
						onclick={handleSectionClick}
					>
						<Fa icon={section.icon} size="sm" />
						<span>{section.title}</span>
					</a>
				{/each}
			</div>
		</div>
	</div>
</Popup>
